export const convertDateToUTC = (dateString: string) => {
	const date = new Date(dateString);
	const date_utc = Date.UTC(
		date.getUTCFullYear(),
		date.getUTCMonth(),
		date.getUTCDate(),
		date.getUTCHours(),
		date.getUTCMinutes(),
		date.getUTCSeconds()
	);

	return new Date(date_utc);
};
